
import { Header, Navbar, LeftSidebar, Footer } from '@/components/partials'
import Vue from 'vue'
export default {
  name: 'App',
  components: {
    Header,
    Navbar,
    LeftSidebar,
    Footer
  },
  computed: {
    //
  },
  data: () => ({}),
  mounted: function () {
    //console.log('App component mounted.');

  },
  created () {
    //
  }
}
